export class Telecarga {
	constructor(
		public version: number,
		public tipo: string,
		public accion: string,
		public codigo: string,
	) {}
}